// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import {
  ADVERTISEMENT_EXPENSES_REDUCER_KEY,
  COST_OF_SALES_CONTD_REDUCER_KEY,
  COST_OF_SALES_REDUCER_KEY,
  GENERAL_ADMINISTRATIVE_EXPENSES_REDUCER_KEY,
  HIRING_PLAN_AVERAGE_REDUCER_KEY,
  OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_REDUCER_KEY,
  OTHER_REVENUE_REDUCER_KEY,
  PROFIT_AND_LOSS_MAIN_REDUCER_KEY,
  SALES_AND_MARKETING_EXPENSES_REDUCER_KEY,
  SUBSCRIPTION_COMMISSIONS_REDUCER_KEY,
  SUBSCRIPTION_REVENUE_REDUCER_KEY,
} from "..";
import { SUBSCRIPTION_REVENUE_KEY as REVENUE_TAB_SUBSCRIPTION_REVENUE_KEY } from "../revenue/subscriptionRevenueReducer";
import { OTHER_REVENUE_KEY } from "../revenue/otherRevenueReducer";
import { TOTAL_SALES_COMMISSIONS_AMOUNT_KEY } from "../revenue/subscriptionCommissionsReducer";
import { CONTENT_PRODUCTION_COST_KEY } from "../cost-and-expenses/costOfSalesReducer";
import { SERVER_COST_KEY as COST_OF_SALES_CONTD_SERVER_COST_KEY } from "../cost-and-expenses/costOfSalesContdReducer";
import { OTHER_OPERATING_EXPENSES_KEY as GEN_ADMIN_OTHER_OPERATING_EXPENSES_KEY } from "../cost-and-expenses/generalAdministrativeExpensesReducer";
import { OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY as CAE_OAME_MAIN_KEY } from "../cost-and-expenses/otherAdvertisementAndMarketingExpensesReducer";
// folder + reducer + key
import { MARKETING_EXPENSES_KEY as CAE_SAM_MARKETING_EXPENSES_KEY } from "../cost-and-expenses/salesAndMarketingExpensesReducer";
import { ADVERTISEMENT_EXPENSES_KEY as CAE_AE_ADVERTISEMENT_EXPENSES_KEY } from "../cost-and-expenses/advertisementExpensesReducer";
import { ADMIN_EXPENSES_KEY } from "../hiring-plan/hiringPlanAverageReducer";
import { hp_fp_foundersAndPartnersHeaderMonth } from "../hiring-plan/staticYearsData";

import {
  UNIT_SALES_REDUCER_KEY,
  UNIT_SALES_TOTAL_INCOME_KEY,
  TOTAL_COST_OF_UNIT_SALES_KEY,
} from "../revenue/unitSalesReducer";

import {
  BILLABLE_HOURS_REDUCER_KEY,
  BILLABLE_HOURS_TOTAL_INCOME_KEY,
  TOTAL_COST_OF_BILLABLE_HOURS_KEY,
} from "../revenue/billableHoursReducer";

import {
  RECURRING_CHARGES_REDUCER_KEY,
  RECURRING_CHARGES_TOTAL_INCOME_KEY,
  TOTAL_COST_OF_RECURRING_CHARGES_KEY,
} from "../revenue/recurringChargesReducer";

import {
  GENERAL_OTHER_REVENUE_REDUCER_KEY,
  GENERAL_OTHER_REVENUE_TOTAL_INCOME_KEY,
  TOTAL_COST_OF_OTHER_REVENUE_KEY,
} from "../revenue/generalOtherRevenueReducer";

import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "pnl_main_";

export const SUBSCRIPTION_REVENUE_KEY = prefix + "subscriptionRevenue";
export const OTHER_REVENUES_KEY = prefix + "otherRevenues";
export const TOTAL_REVENUES_KEY = prefix + "totalRevenues";

export const TOTAL_UNIT_SALES_KEY = prefix + "totalUnitSales";
export const TOTAL_BILLABLE_HOURS_KEY = prefix + "totalBillableHours";
export const TOTAL_RECURRING_CHARGES_KEY = prefix + "totalRecurringCharges";
export const TOTAL_GENERAL_OTHER_REVENUES_KEY =
  prefix + "totalGeneralOtherRevenues";

export const REVENUE_GROWTH_KEY = prefix + "revenueGrowth";
export const YOY_GROWTH_KEY = prefix + "yoyGrowth";

export const COST_OF_UNIT_SALES_KEY = prefix + "costOfUnitSales";
export const COST_OF_BILLABLE_HOURS_KEY = prefix + "costOfBillableHours";
export const COST_OF_RECURRING_CHARGES_KEY = prefix + "costOfRecurringCharges";
export const COST_OF_OTHER_REVENUE_KEY = prefix + "costOfOtherRevenue";

export const APP_STORE_COMMISSIONS_KEY = prefix + "appStoreCommissions";
export const CONTENT_AND_PRODUCTION_COSTS_KEY =
  prefix + "contentAndProductionCosts";
export const SERVER_COST_KEY = prefix + "serverCost";
export const GROSS_PROFIT_KEY = prefix + "grossProfit";
export const GROSS_PROFIT_MARGIN_KEY = prefix + "grossProfitMargin";
export const PERSONNEL_EXPENSES_KEY = prefix + "personnelExpenses";
export const OTHER_OPERATING_EXPENSES_KEY = prefix + "otherOperatingExpenses";
export const GEN_ADMIN_EXPENSES_KEY = prefix + "genAdminExpenses";
export const MARKETING_EXPENSES_KEY = prefix + "marketingExpenses";
export const ADVERTISEMENT_EXPENSES_KEY = prefix + "advertisementExpenses";
export const OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY =
  prefix + "otherAdvMarketingExpenses";
export const S_AND_M_EXPENSES_KEY = prefix + "sAndMExpenses";
export const EBITDA_KEY = prefix + "ebitda";
export const EBITDA_MARGIN_KEY = prefix + "ebitdaMargin";

export const profitAndLossItems = [
  SUBSCRIPTION_REVENUE_KEY,
  OTHER_REVENUES_KEY,

  TOTAL_UNIT_SALES_KEY,
  TOTAL_BILLABLE_HOURS_KEY,
  TOTAL_RECURRING_CHARGES_KEY,
  TOTAL_GENERAL_OTHER_REVENUES_KEY,

  TOTAL_REVENUES_KEY,
  REVENUE_GROWTH_KEY,
  YOY_GROWTH_KEY,

  COST_OF_UNIT_SALES_KEY,
  COST_OF_BILLABLE_HOURS_KEY,
  COST_OF_RECURRING_CHARGES_KEY,
  COST_OF_OTHER_REVENUE_KEY,

  APP_STORE_COMMISSIONS_KEY,
  CONTENT_AND_PRODUCTION_COSTS_KEY,
  SERVER_COST_KEY,
  GROSS_PROFIT_KEY,
  GROSS_PROFIT_MARGIN_KEY,
  PERSONNEL_EXPENSES_KEY,
  OTHER_OPERATING_EXPENSES_KEY,
  GEN_ADMIN_EXPENSES_KEY,
  MARKETING_EXPENSES_KEY,
  ADVERTISEMENT_EXPENSES_KEY,
  OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY,
  S_AND_M_EXPENSES_KEY,
  EBITDA_KEY,
  EBITDA_MARGIN_KEY,
];

export const initialState = {
  [SUBSCRIPTION_REVENUE_KEY]: {
    title: "Subscription Revenue",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
        REVENUE_TAB_SUBSCRIPTION_REVENUE_KEY
      ].calculate(yearKey, getReducerFunc, companyType);
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [OTHER_REVENUES_KEY]: {
    title: "Other Revenues",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      // OTHER_REVENUE_KEY is an INPUT
      return getReducerFunc(OTHER_REVENUE_REDUCER_KEY)[OTHER_REVENUE_KEY][
        "years"
      ][yearKey];
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [TOTAL_REVENUES_KEY]: {
    title: "Revenues",
    highlight: true,
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      if (companyType === SaaSCoType) {
        return (
          Number(
            getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
              SUBSCRIPTION_REVENUE_KEY
            ].calculate(yearKey, getReducerFunc, companyType)
          ) +
          Number(
            getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
              OTHER_REVENUES_KEY
            ].calculate(yearKey, getReducerFunc, companyType)
          )
        );
      } else if (companyType === GeneralCoType) {
        return (
          Number(
            getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
              TOTAL_UNIT_SALES_KEY
            ].calculate(yearKey, getReducerFunc, companyType)
          ) +
          Number(
            getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
              TOTAL_BILLABLE_HOURS_KEY
            ].calculate(yearKey, getReducerFunc, companyType)
          ) +
          Number(
            getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
              TOTAL_RECURRING_CHARGES_KEY
            ].calculate(yearKey, getReducerFunc, companyType)
          ) +
          Number(
            getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
              TOTAL_GENERAL_OTHER_REVENUES_KEY
            ].calculate(yearKey, getReducerFunc, companyType)
          )
        );
      }

      return -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [TOTAL_UNIT_SALES_KEY]: {
    title: "Unit Sales",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return Number(
        getReducerFunc(UNIT_SALES_REDUCER_KEY)[
          UNIT_SALES_TOTAL_INCOME_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [TOTAL_BILLABLE_HOURS_KEY]: {
    title: "Billable Hours",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return Number(
        getReducerFunc(BILLABLE_HOURS_REDUCER_KEY)[
          BILLABLE_HOURS_TOTAL_INCOME_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [TOTAL_RECURRING_CHARGES_KEY]: {
    title: "Recurring Charges",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return Number(
        getReducerFunc(RECURRING_CHARGES_REDUCER_KEY)[
          RECURRING_CHARGES_TOTAL_INCOME_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [TOTAL_GENERAL_OTHER_REVENUES_KEY]: {
    title: "Other Revenues",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return Number(
        getReducerFunc(GENERAL_OTHER_REVENUE_REDUCER_KEY)[
          GENERAL_OTHER_REVENUE_TOTAL_INCOME_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [REVENUE_GROWTH_KEY]: {
    title: "Growth",
    highlight: true,
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const key2use = TOTAL_REVENUES_KEY;

      let previousTotalRevenues = 0;
      if (yearKey > 1) {
        previousTotalRevenues = getReducerFunc(
          PROFIT_AND_LOSS_MAIN_REDUCER_KEY
        )[key2use].calculate(yearKey - 1, getReducerFunc, companyType);
      }

      const currentTotalRevenues = getReducerFunc(
        PROFIT_AND_LOSS_MAIN_REDUCER_KEY
      )[key2use].calculate(yearKey, getReducerFunc, companyType);

      const result = (currentTotalRevenues / previousTotalRevenues - 1) * 100;

      return Number.isNaN(result) || !Number.isFinite(result)
        ? 0
        : result >= 500 || result <= -500
        ? "n.m."
        : result;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [YOY_GROWTH_KEY]: {
    title: "YoY Growth (x)",
    highlight: true,
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const key2use = TOTAL_REVENUES_KEY;

      let previousTotalRevenues = 0;
      if (yearKey > 1) {
        previousTotalRevenues = getReducerFunc(
          PROFIT_AND_LOSS_MAIN_REDUCER_KEY
        )[key2use].calculate(yearKey - 1, getReducerFunc, companyType);
      }

      const currentTotalRevenues = getReducerFunc(
        PROFIT_AND_LOSS_MAIN_REDUCER_KEY
      )[key2use].calculate(yearKey, getReducerFunc, companyType);

      const result = currentTotalRevenues / previousTotalRevenues;

      return Number.isNaN(result) || !Number.isFinite(result)
        ? 0
        : result.toFixed(2);
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [COST_OF_UNIT_SALES_KEY]: {
    title: "Cost of Unit Sales",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const totalCost = Number(
        getReducerFunc(UNIT_SALES_REDUCER_KEY)[
          TOTAL_COST_OF_UNIT_SALES_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      return totalCost === 0 ? 0 : totalCost * -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [COST_OF_BILLABLE_HOURS_KEY]: {
    title: "Cost of Billable Hours",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const totalCost = Number(
        getReducerFunc(BILLABLE_HOURS_REDUCER_KEY)[
          TOTAL_COST_OF_BILLABLE_HOURS_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      return totalCost === 0 ? 0 : totalCost * -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [COST_OF_RECURRING_CHARGES_KEY]: {
    title: "Cost of Recurring Charges",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const totalCost = Number(
        getReducerFunc(RECURRING_CHARGES_REDUCER_KEY)[
          TOTAL_COST_OF_RECURRING_CHARGES_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      return totalCost === 0 ? 0 : totalCost * -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [COST_OF_OTHER_REVENUE_KEY]: {
    title: "Cost of Other Revenue",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const totalCost = Number(
        getReducerFunc(GENERAL_OTHER_REVENUE_REDUCER_KEY)[
          TOTAL_COST_OF_OTHER_REVENUE_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      return totalCost === 0 ? 0 : totalCost * -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [APP_STORE_COMMISSIONS_KEY]: {
    title: "App Store Commissions",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      if (companyType === GeneralCoType) {
        return 0;
      }
      // Revenue Tab - Total Sales Commissions * -1
      return (
        getReducerFunc(SUBSCRIPTION_COMMISSIONS_REDUCER_KEY)[
          TOTAL_SALES_COMMISSIONS_AMOUNT_KEY
        ].calculate(yearKey, getReducerFunc, companyType) * -1
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,

    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [CONTENT_AND_PRODUCTION_COSTS_KEY]: {
    title: "Content & Production Costs",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      if (companyType === GeneralCoType) {
        return 0;
      }
      // Cost and Expenses - Content and Production Costs
      return (
        getReducerFunc(COST_OF_SALES_REDUCER_KEY)[
          CONTENT_PRODUCTION_COST_KEY
        ].calculate(yearKey, getReducerFunc, companyType) * -1
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [SERVER_COST_KEY]: {
    title: "Server Cost",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      if (companyType === GeneralCoType) {
        return 0;
      }
      // Cost and Expenses - Content and Production Costs
      const result = getReducerFunc(COST_OF_SALES_CONTD_REDUCER_KEY)[
        COST_OF_SALES_CONTD_SERVER_COST_KEY
      ].calculate(yearKey, getReducerFunc, companyType);

      return result === 0 ? 0 : result * -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [GROSS_PROFIT_KEY]: {
    title: "Gross Profit",
    highlight: true,
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const key2use = TOTAL_REVENUES_KEY;
      return (
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[key2use].calculate(
            yearKey,
            getReducerFunc,
            companyType
          )
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            APP_STORE_COMMISSIONS_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            CONTENT_AND_PRODUCTION_COSTS_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            SERVER_COST_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        )
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [GROSS_PROFIT_MARGIN_KEY]: {
    title: "Gross Profit Margin",
    highlight: true,
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const currentTotalRevenues = getReducerFunc(
        PROFIT_AND_LOSS_MAIN_REDUCER_KEY
      )[TOTAL_REVENUES_KEY].calculate(yearKey, getReducerFunc, companyType);

      const currentGrossProfit = getReducerFunc(
        PROFIT_AND_LOSS_MAIN_REDUCER_KEY
      )[GROSS_PROFIT_KEY].calculate(yearKey, getReducerFunc, companyType);

      const result = currentGrossProfit / currentTotalRevenues;

      return Number.isNaN(result) || !Number.isFinite(result)
        ? 0
        : result.toFixed(3) * 100;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [PERSONNEL_EXPENSES_KEY]: {
    title: "Personnel Expenses",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        getReducerFunc(HIRING_PLAN_AVERAGE_REDUCER_KEY)[
          ADMIN_EXPENSES_KEY
        ].calculate(yearKey, getReducerFunc, companyType) * -1
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,

    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [OTHER_OPERATING_EXPENSES_KEY]: {
    title: "Other Operating Expenses",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const result = getReducerFunc(
        GENERAL_ADMINISTRATIVE_EXPENSES_REDUCER_KEY
      )[GEN_ADMIN_OTHER_OPERATING_EXPENSES_KEY].calculate(
        yearKey,
        getReducerFunc,
        companyType
      );
      return result === 0 ? 0 : result.toFixed(0) * -1;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [GEN_ADMIN_EXPENSES_KEY]: {
    title: "General Administrative Expenses",
    highlight: true,
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            PERSONNEL_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            OTHER_OPERATING_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        )
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [MARKETING_EXPENSES_KEY]: {
    title: "Marketing Expenses",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      // Cost and Expenses - Marketing Expenses * -1
      return (
        getReducerFunc(SALES_AND_MARKETING_EXPENSES_REDUCER_KEY)[
          CAE_SAM_MARKETING_EXPENSES_KEY
        ].calculate(yearKey, getReducerFunc, companyType) * -1
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [ADVERTISEMENT_EXPENSES_KEY]: {
    title: "Advertisement Expenses",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      // Cost and Expenses - Marketing Expenses * -1
      return (
        getReducerFunc(ADVERTISEMENT_EXPENSES_REDUCER_KEY)[
          CAE_AE_ADVERTISEMENT_EXPENSES_KEY
        ].calculate(yearKey, getReducerFunc, companyType) * -1
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY]: {
    title: "Other Advertisement & Marketing Expenses",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      // Cost and Expenses - Marketing Expenses * -1
      return (
        getReducerFunc(OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_REDUCER_KEY)[
          CAE_OAME_MAIN_KEY
        ].calculate(yearKey, getReducerFunc, companyType) * -1
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [S_AND_M_EXPENSES_KEY]: {
    title: "Sales & Marketing Expenses",
    highlight: true,
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            MARKETING_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            ADVERTISEMENT_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        )
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [EBITDA_KEY]: {
    title: "EBITDA",
    highlight: true,
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            GROSS_PROFIT_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            GEN_ADMIN_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        ) +
        Number(
          getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
            S_AND_M_EXPENSES_KEY
          ].calculate(yearKey, getReducerFunc, companyType)
        )
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [EBITDA_MARGIN_KEY]: {
    title: "EBITDA Margin",
    highlight: true,
    unit: unitType.PERCENTAGE,
    unitSymbol: getUnitSymbolByUnit(unitType.PERCENTAGE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const currentEbitda = getReducerFunc(PROFIT_AND_LOSS_MAIN_REDUCER_KEY)[
        EBITDA_KEY
      ].calculate(yearKey, getReducerFunc, companyType);

      const currentTotalRevenues = getReducerFunc(
        PROFIT_AND_LOSS_MAIN_REDUCER_KEY
      )[TOTAL_REVENUES_KEY].calculate(yearKey, getReducerFunc, companyType);

      const result = (currentEbitda / currentTotalRevenues) * 100;

      return Number.isNaN(result) || !Number.isFinite(result)
        ? 0
        : result.toFixed(2);
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const profitAndLossMainReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROFIT_AND_LOSS_MAIN_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_PROFIT_AND_LOSS_MAIN_BY_MONTHS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_PROFIT_AND_LOSS_MAIN_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_PROFIT_AND_LOSS_MAIN_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default profitAndLossMainReducer;
